<div
  class="home__categories__container"
  (mouseenter)="pauseAutoPlay()"
  (mouseleave)="resumeAutoPlay()"
  (focusin)="pauseAutoPlay()"
  (focusout)="resumeAutoPlay()"
  (touchstart)="pauseAutoPlay()"
  (touchend)="resumeAutoPlay()"
>
  <div class="categories__header">
    <div class="categories__header-left">
      <h2 class="categories__header-title">{{ headerKey | translate }}</h2>
    </div>
    <a class="categories__view-all" [routerLink]="['/product']"
      [queryParams]="getViewAllQueryParams()">
      <span>{{ 'home.categories.view_all' | translate }}</span>
      <mat-icon class="categories__view-all-icon">arrow_forward</mat-icon>
    </a>
  </div>

  <div
    class="categories__carousel-wrapper"
    role="region"
    [attr.aria-label]="headerKey | translate"
  >
    <div
      #carouselTrack
      class="categories__item__container"
      (scroll)="onTrackScroll()"
      (keydown.arrowLeft)="prevSlide()"
      (keydown.arrowRight)="nextSlide()"
    >
      <ng-container *ngIf="isPagedLayout; else desktopItemsTpl">
        <div
          *ngFor="let page of pagedItems; trackBy: trackByPageIndex"
          class="categories__page"
        >
          <a
            *ngFor="let item of page; trackBy: trackByCategoryId"
            class="categories__item"
            [class.is-placeholder]="!getImage(item.imageUrl)"
            [routerLink]="['/product']"
            [queryParams]="getItemQueryParams(item)"
          >
            <ng-container *ngTemplateOutlet="categoryCardContent; context: { $implicit: item }"></ng-container>
          </a>
        </div>
      </ng-container>

      <ng-template #desktopItemsTpl>
        <a
          *ngFor="let item of items; trackBy: trackByCategoryId"
          class="categories__item"
          [class.is-placeholder]="!getImage(item.imageUrl)"
          [routerLink]="['/product']"
          [queryParams]="getItemQueryParams(item)"
        >
          <ng-container *ngTemplateOutlet="categoryCardContent; context: { $implicit: item }"></ng-container>
        </a>
      </ng-template>

      <ng-template #categoryCardContent let-item>
        <div class="categories__image-wrapper">
          <div class="categories__circle">
          <img
            *ngIf="getImage(item.imageUrl)"
            [src]="getImage(item.imageUrl)"
            [alt]="item.name"
            loading="lazy"
            decoding="async"
          />

          <div *ngIf="!getImage(item.imageUrl)" class="no-image-placeholder">
            <div class="placeholder-emblem">
              <mat-icon>{{ getCategoryIcon(item.name) }}</mat-icon>
            </div>
          </div>
          </div>

          <div class="categories__content">
            <div class="categories__text-group">
              <h3 class="categories__title">{{ item.name }}</h3>
              <p class="categories__count">{{ 'home.categories.product_count' | translate: { count: item.totalProducts ?? 0 } }}</p>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <ng-container *ngIf="showNavControls">
      <button
        type="button"
        class="carousel__nav-circle carousel__nav-circle--prev"
        (click)="prevSlide()"
        aria-label="Previous categories"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        type="button"
        class="carousel__nav-circle carousel__nav-circle--next"
        (click)="nextSlide()"
        aria-label="Next categories"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </ng-container>
  </div>

  <ng-content select="[category-filter]"></ng-content>
</div>
